import React from "react";

export const PageNotFound:React.FC = () => {
  // Currently we don't have mock for Page not found.
  // Keeping it blank as per current SSR implementation
  return (
    <></>
  );
};